import { forwardRef, useState } from "react";
import { useDataProvider, useTranslate } from "react-admin";

import { ExportDialogButton } from "organisms";
import { defaultListFetchParams } from "misc/edmClient";
import { eventFieldsets, descriptionFieldsetsFromEventTypes } from "misc/exportFieldsets";

function ExportEventsButton(props, ref) {
  const { selectedIds, closeMenu = false } = props;
  const dataProvider = useDataProvider();
  const translate = useTranslate();
  const [descriptionFieldsets, setDescriptionFieldsets] = useState([]);

  const fetchDescriptionFieldsets = async () => {
    const fetchParams = {
      ...defaultListFetchParams,
      filter: {
        /*for_events: selectedIds*/
      },
    };
    const result = await dataProvider.getList("event_types", fetchParams);
    const descriptionFieldsets = descriptionFieldsetsFromEventTypes(translate, result.data);
    setDescriptionFieldsets(descriptionFieldsets);
  };

  return (
    <ExportDialogButton
      passedRef={ref}
      resource="events"
      fetchEntities={fetchDescriptionFieldsets}
      selectedIds={selectedIds}
      fieldsets={eventFieldsets}
      descriptionFieldsets={descriptionFieldsets}
      closeMenu={closeMenu}
      label="export.actions.event"
    />
  );
}

export default forwardRef(ExportEventsButton);
